import React from 'react'
import dynamic from 'next/dynamic'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, GridItem, Heading } from '@chakra-ui/react'
import { Offer, AutoPromo, ActionBar } from 'src/components/SellOffers/'
import { useTranslation } from 'react-i18next'
import { setListingPage } from 'src/redux/sell-offer'

const Pagination = dynamic(() => import('src/components/Paginator/Pagination'))
const HomeOffersList = dynamic(() => import('src/components/SellOffers/HomeOffersList'))

const LandingSellOffersContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const filterMenuIsOpen = useSelector((state: Store.RootState) => state.sell.filterMenuIsOpen)
  const offers = useSelector((state: Store.RootState) => state.sell.filteredOffers)
  const otherOffers = useSelector((state: Store.RootState) => state.sell.offers)

  const onPaginatorClickHandler = page => dispatch(setListingPage(page))

  return <>
    {offers.items && offers.items.length ?
      <>
        <ActionBar offersCount={offers.items.length} />
        <Grid
          templateColumns={{
            md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
            lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`,
          }}
          gap={6}
          px="l"
          pt="xxs"
        >
          {offers.items.map(item => {
            return item.code === 'auto-promo' ?
              (<GridItem key={`${item.code}- ${item.title} `}>
                <AutoPromo item={item} />
              </GridItem>)
              :
              (<GridItem key={item.code}>
                <Offer item={item} />
              </GridItem>)
          })}
          <GridItem
            colSpan={{
              md: filterMenuIsOpen ? 2 : 3,
              lg: filterMenuIsOpen ? 3 : 4
            }}
            mt="-2"
            textAlign="left"
            key="load-more"
          >
            <Pagination
              currentPage={offers.currentPage}
              perPage={offers.pageSize}
              total={offers.results}
              onClick={onPaginatorClickHandler}
            />
          </GridItem>
        </Grid>
      </>
      :
      <>
        <GridItem colSpan={{
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        }}>
          <Heading as="h3" fontSize="2xl" fontFamily="Montserrat-SemiBold">{t('sellPage:notFound')}</Heading>
        </GridItem>
        <GridItem colSpan={{
          md: filterMenuIsOpen ? 2 : 3,
          lg: filterMenuIsOpen ? 3 : 4
        }}>
          <HomeOffersList
            w="100%"
            action={t('indexPage:sell_offers.action')}
            alt={t('indexPage:sell_offers.alt')}
            href="/offerte-auto"
            offers={otherOffers}
            paddingLeft="l"
            paddingRight="l"
            bgColor="baseNeutral.100"
          />
        </GridItem>
      </>
    }
  </>
}

export default LandingSellOffersContainer
